import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TripCard from "components/shared/stays/TripCard";
import Button from "solar/components/Button";
import styles from "components/shared/stays/PaginateTrips.module.scss";

export default function PaginateTrips({ trips = null, initialTripCount }) {
  const [isTruncated, setIsTruncated] = useState(
    initialTripCount < trips.length
  );
  const [displayedTrips, setDisplayedTrips] = useState(null);

  useEffect(() => {
    setIsTruncated(initialTripCount < trips.length);
  }, [initialTripCount, trips]);

  useEffect(() => {
    setDisplayedTrips(isTruncated ? trips.slice(0, initialTripCount) : trips);
  }, [isTruncated, trips, initialTripCount]);

  return (
    <div>
      {displayedTrips && (
        <>
          <div className={styles.list}>
            {displayedTrips.map((trip) => (
              <TripCard
                key={trip.id}
                name={trip.name}
                slug={trip.slug}
                country={trip.country}
                lowestPrice={trip.lowest_price_per_person_per_night}
                pricingType={trip.lowest_product_pricing_type}
                typeDescription={trip.trip_type_description}
                isFeatured={trip.is_featured}
                reviewScores={trip.review_scores}
                imageUrl={trip.main_image?.url}
                tripID={trip.id}
              />
            ))}
          </div>
          {isTruncated && (
            <Button
              className={styles.button}
              onClick={() => {
                setIsTruncated(false);
              }}
              responsive
            >
              {`Show all ${trips.length} trips`}
            </Button>
          )}
        </>
      )}
    </div>
  );
}

PaginateTrips.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      slug: PropTypes.string,
      country: PropTypes.string,
      lowest_price_per_person_per_night: PropTypes.node,
      lowest_product_pricing_type: PropTypes.string,
      trip_type_description: PropTypes.string,
      is_featured: PropTypes.bool,
      review_scores: PropTypes.arrayOf(PropTypes.number),
      main_image: PropTypes.shape({
        url: PropTypes.string,
      }),
    })
  ).isRequired,
  initialTripCount: PropTypes.number.isRequired,
};
